
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/pasm-strategic-initiative",
      function () {
        return require("private-next-pages/solutions/pasm-strategic-initiative/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/pasm-strategic-initiative"])
      });
    }
  